import { render } from "./createInvoiceDialog.vue?vue&type=template&id=0b15bb46"
import script from "./createInvoiceDialog.vue?vue&type=script&lang=js"
export * from "./createInvoiceDialog.vue?vue&type=script&lang=js"

import "./createInvoiceDialog.vue?vue&type=style&index=0&id=0b15bb46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__